import { API_URL } from "../../../../URL";
import { TOGGLE_CHECKLIST_ITEM } from "../../../constants";

export const CheckListItemHandleAPI = (itemId, checklistId, isChecked) => {
    return async (dispatch) => {
        try {
            const res = await fetch(`${API_URL}/post/handle_checklist/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    id: itemId,
                    checklist_id: checklistId,
                    is_checked: !isChecked
                }),
            });

            const data = await res.json();

            dispatch({
                type: TOGGLE_CHECKLIST_ITEM,
                payload: {
                    itemId,
                    checklistId,
                    value: data.is_checked
                }
            });
        } catch (err) {
            console.error(err);
        }
    };
};